import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

export const Container = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.625rem 0;

    & + & {
      border-top: 1px solid ${theme.colors.base.border};
    }
  `}
`;

const medalEmojis: Record<number, string> = {
  1: '\uD83E\uDD47',
  2: '\uD83E\uDD48',
  3: '\uD83E\uDD49',
};

type PositionProps = TransientProps<{ position: number }>;

export const Position = styled.span<PositionProps>`
  ${({ theme, $position: position }) => css`
    width: 1.75rem;
    text-align: center;
    font-size: ${position <= 3 ? '1.25rem' : '0.875rem'};
    font-weight: 700;
    color: ${theme.colors.foreground[40]};
    flex-shrink: 0;

    ${position <= 3 &&
    css`
      ::after {
        content: '${medalEmojis[position]}';
      }
    `}
  `}
`;

export const UserInfo = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-width: 0;

    strong {
      display: block;
      font-size: 0.875rem;
      font-weight: 600;
      color: ${theme.colors.foreground[100]};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span {
      display: block;
      font-size: 0.75rem;
      color: ${theme.colors.foreground[40]};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `}
`;

const scorePillColors: Record<number, { bg: string; text: string }> = {
  1: { bg: '#FFF4D9', text: '#E8A500' },
  2: { bg: '#F3F4F6', text: '#7A7A8A' },
  3: { bg: '#FEF3EC', text: '#C7A276' },
};

const defaultScorePill = { bg: '#F3F4F6', text: '#7A7A8A' };

export const ScorePill = styled.span<PositionProps>`
  ${({ $position: position }) => {
    const colors = scorePillColors[position] || defaultScorePill;

    return css`
      display: grid;
      place-content: center;
      padding: 0.25rem 0.625rem;
      border-radius: 9999px;
      font-size: 0.6875rem;
      font-weight: 700;
      background: ${colors.bg};
      color: ${colors.text};
      flex-shrink: 0;
      white-space: nowrap;
    `;
  }}
`;
